/** Public compiled module names. Keep this closed catalog aligned with server source files. */
export const SERVER_CODE_FILES = new Set([
  'server/access.js',
  'server/account/deleteAccount.js',
  'server/account/emails.js',
  'server/account/passwordReset.js',
  'server/admin/duplicatePeople.js',
  'server/admin/mergeTeams.js',
  'server/admin/nodeAdministration.js',
  'server/admin/people.js',
  'server/appLinks/appOrigin.js',
  'server/appLinks/config.js',
  'server/auth/apiKeyFamilies.js',
  'server/auth/codeDelivery.js',
  'server/auth/deviceEventControl.js',
  'server/auth/emailCodes.js',
  'server/auth/emails.js',
  'server/auth/passwords.js',
  'server/auth/rateLimit.js',
  'server/auth/sessions.js',
  'server/auth/settleAccount.js',
  'server/auth/tokens.js',
  'server/auth/tvLocation.js',
  'server/auth/tvLogin.js',
  'server/autoScheduler/attention.js',
  'server/autoScheduler/buildOffThread.js',
  'server/autoScheduler/cancel.js',
  'server/autoScheduler/previews.js',
  'server/autoScheduler/propose.js',
  'server/autoScheduler/publish.js',
  'server/autoScheduler/reschedule.js',
  'server/autoScheduler/rules.js',
  'server/autoScheduler/schedulePreviewsOpenApi.js',
  'server/autoScheduler/snapshot.js',
  'server/backgroundJobs.js',
  'server/buildVersion.js',
  'server/cache/valkeyCache.js',
  'server/changeFeed/feed.js',
  'server/changeFeed/feedSubscribers.js',
  'server/changeFeed/feedTestKit.js',
  'server/changeFeed/makeChangeFeed.js',
  'server/changeFeed/postgresFeed.js',
  'server/changeFeed/probeCli.js',
  'server/changeFeed/relay.js',
  'server/changeFeed/valkeyFeed.js',
  'server/chat/attachments.js',
  'server/chat/audiences.js',
  'server/chat/chatTestDevices.js',
  'server/chat/chatTestFixture.js',
  'server/chat/dms.js',
  'server/chat/epochs.js',
  'server/chat/keys.js',
  'server/chat/listing.js',
  'server/chat/membershipLog.js',
  'server/chat/messages.js',
  'server/chat/preferences.js',
  'server/chat/reconciler.js',
  'server/chat/titles.js',
  'server/chat/wire.js',
  'server/clock.js',
  'server/db/advisoryLocks.js',
  'server/db/anyOf.js',
  'server/db/atomic.js',
  'server/db/database.js',
  'server/db/externalIds.js',
  'server/db/int8.js',
  'server/db/readSnapshot.js',
  'server/db/realVideos.js',
  'server/db/syncIdempotency.js',
  'server/db/teamLookups.js',
  'server/dev/auditVideos.js',
  'server/dev/backfillLinescore.js',
  'server/dev/backfillPlateAppearances.js',
  'server/dev/cameraSweep.js',
  'server/dev/chatSeed.js',
  'server/dev/demo.js',
  'server/dev/demoStats.js',
  'server/dev/duplicatePeople.js',
  'server/dev/fakeSpace.js',
  'server/dev/importArchiveCameras.js',
  'server/dev/importInvites.js',
  'server/dev/importVideoFile.js',
  'server/dev/lineupFixture.js',
  'server/dev/livePitch.js',
  'server/dev/makeSampleVideo.js',
  'server/dev/makeSeasonFromVideos.js',
  'server/dev/mergeTeam.js',
  'server/dev/migratePeertubeToSpaces.js',
  'server/dev/namesFixture.js',
  'server/dev/postStatsFixture.js',
  'server/dev/refoldScoredGames.js',
  'server/dev/repairPeople.js',
  'server/dev/replaySeed.js',
  'server/dev/rosterCacheEpoch.js',
  'server/dev/samePerson.js',
  'server/dev/scopeAgreementCheck.js',
  'server/dev/scoringGame.js',
  'server/dev/seed.js',
  'server/dev/statsTablesSeed.js',
  'server/dev/userIdApiCapture.js',
  'server/dev/userIdCheck.js',
  'server/dev/userIdCompare.js',
  'server/dev/userIdOrdering.js',
  'server/dev/userIdSnapshot.js',
  'server/dev/userIdTransforms.js',
  'server/dev/validateGumbo.js',
  'server/dictation/gameStateSummary.js',
  'server/dictation/interpreter.js',
  'server/dictation/models.js',
  'server/dictation/placeInstructions.js',
  'server/dictation/promptCases.integration.js',
  'server/dictation/route.js',
  'server/dictation/scopes.js',
  'server/dictation/stt.js',
  'server/director/discard.js',
  'server/director/purge.js',
  'server/director/runGames.js',
  'server/director/uploads.js',
  'server/email/accountMail.js',
  'server/email/sendMail.js',
  'server/events/credits.js',
  'server/events/eventChildren.js',
  'server/events/eventInfo.js',
  'server/events/eventInfoOpenApi.js',
  'server/events/eventListQuery.js',
  'server/events/eventTags.js',
  'server/events/atBatInProgress.js',
  'server/events/currentPlay.js',
  'server/events/eventWrite.js',
  'server/events/playEventTimes.js',
  'server/events/playedTogether.js',
  'server/events/playerRsvps.js',
  'server/events/postPlays.js',
  'server/events/radarSpeeds.js',
  'server/events/requireVisibleGame.js',
  'server/events/teamLineups.js',
  'server/events/videoCollections.js',
  'server/events/videoSearchDetails.js',
  'server/events/wireRecords.js',
  'server/events/whyEmpty.js',
  'server/games/fenceDistance.js',
  'server/games/gameLive.js',
  'server/games/guestChecks.js',
  'server/games/guestPlayers.js',
  'server/games/opponentFixed.js',
  'server/games/resetSwap.js',
  'server/games/retargetTeams.js',
  'server/games/rosterAvailability.js',
  'server/games/scoringActivity.js',
  'server/games/swapEffect.js',
  'server/games/swapSides.js',
  'server/games/unroster.js',
  'server/games/withdrawn.js',
  'server/graphql/restReader.js',
  'server/graphql/schema.js',
  'server/graphql/statsField.js',
  'server/groups/adminGuard.js',
  'server/groups/createGroup.js',
  'server/groups/follows.js',
  'server/groups/groupPhoto.js',
  'server/groups/guardianLimits.js',
  'server/groups/noticePolicy.js',
  'server/groups/openApi.js',
  'server/groups/ownershipPreflight.js',
  'server/groups/playerNamePrivacy.js',
  'server/groups/publicSummary.js',
  'server/groups/relatedTeams.js',
  'server/groups/relationships.js',
  'server/groups/requests.js',
  'server/groups/rights.js',
  'server/groups/teamMerge.js',
  'server/highlights.js',
  'server/home/homeLists.js',
  'server/index.js',
  'server/ingest/main.js',
  'server/ingest/run.js',
  'server/ingest/survive.e2e.js',
  'server/invites/grants.js',
  'server/invites/invites.js',
  'server/invites/joining.js',
  'server/invites/people.js',
  'server/invites/personRequests.js',
  'server/jsonBody.js',
  'server/live/controller.js',
  'server/live/decoderConfig.js',
  'server/live/finishVideo.js',
  'server/live/frameWallFixture.js',
  'server/live/holeFiller.js',
  'server/live/ingestQuiet.js',
  'server/live/originFixtures.js',
  'server/live/originPublish.js',
  'server/live/originPublisher.js',
  'server/live/quietStream.js',
  'server/live/receiving.js',
  'server/live/revokeStreams.js',
  'server/live/secrets.js',
  'server/live/segmentClock.js',
  'server/live/splitter.js',
  'server/live/splitterFixtures.js',
  'server/live/streamKeys.js',
  'server/live/timestampJump.js',
  'server/live/wallAnchors.js',
  'server/livingWorkers.js',
  'server/location/coordinateTimezone.js',
  'server/location/eventGeocoder.js',
  'server/location/eventPlaces.js',
  'server/location/googleLookupLimits.js',
  'server/location/googlePlaces.js',
  'server/location/places.js',
  'server/media/cameras.js',
  'server/media/codecString.js',
  'server/media/deleteVideo.js',
  'server/media/diskSpace.js',
  'server/media/ffmpeg.js',
  'server/media/imageUrls.js',
  'server/media/images.js',
  'server/media/ingestFile.js',
  'server/media/locations.js',
  'server/media/mediaContext.js',
  'server/media/mediaOrigins.js',
  'server/media/mediaTokens.js',
  'server/media/pictureCatalog.js',
  'server/media/posters.js',
  'server/media/presign.js',
  'server/media/spaceFrames.js',
  'server/media/spacesHls.js',
  'server/media/spacesVideo.js',
  'server/media/startTime.js',
  'server/media/stills.js',
  'server/media/trackStarts.js',
  'server/media/videoStills.js',
  'server/media/wallClockScan.js',
  'server/media/wallClockStamp.js',
  'server/media/wallTimeline.js',
  'server/middleware/apiKeyCeiling.js',
  'server/middleware/withAudit.js',
  'server/middleware/withAuth.js',
  'server/middleware/withCors.js',
  'server/middleware/withErrors.js',
  'server/nodeSettings.js',
  'server/notifications/completionNotice.js',
  'server/notifications/inbox.js',
  'server/notifications/recordingReminders.js',
  'server/notifications/requestInformation.js',
  'server/oauth/adapter.js',
  'server/oauth/config.js',
  'server/oauth/maintenance.js',
  'server/oauth/provider.js',
  'server/oauth/routes.js',
  'server/observability/analytics.js',
  'server/observability/logging.js',
  'server/observability/outcomes.js',
  'server/observability/query.js',
  'server/observability/routes.js',
  'server/observability/service.js',
  'server/openAdds.js',
  'server/openapi.js',
  'server/people/guardians.js',
  'server/replay/narrationAudio.js',
  'server/replay/replayable.js',
  'server/replay/speech.js',
  'server/routes/account.js',
  'server/routes/admin.js',
  'server/routes/apiKeys.js',
  'server/routes/appLinks.js',
  'server/routes/auth.js',
  'server/routes/chat.js',
  'server/routes/chatAttachments.js',
  'server/routes/chatEpochs.js',
  'server/routes/chatKeys.js',
  'server/routes/chatMessages.js',
  'server/routes/devMedia.js',
  'server/routes/deviceEventControl.js',
  'server/routes/director.js',
  'server/routes/directorUploads.js',
  'server/routes/eventInfo.js',
  'server/routes/eventList.js',
  'server/routes/events.js',
  'server/routes/follows.js',
  'server/routes/gameApprovals.js',
  'server/routes/gameWritten.js',
  'server/routes/graphql.js',
  'server/routes/groups.js',
  'server/routes/guardians.js',
  'server/routes/health.js',
  'server/routes/invites.js',
  'server/routes/lineups.js',
  'server/routes/live.js',
  'server/routes/location.js',
  'server/routes/manage.js',
  'server/routes/me.js',
  'server/routes/media.js',
  'server/routes/narrations.js',
  'server/routes/nodeAdministration.js',
  'server/routes/notifications.js',
  'server/routes/onboarding.js',
  'server/routes/people.js',
  'server/routes/pictures.js',
  'server/routes/players.js',
  'server/routes/publicGames.js',
  'server/routes/schedule.js',
  'server/routes/schedulePreviews.js',
  'server/routes/schedulingSetup.js',
  'server/routes/scoreboard.js',
  'server/routes/seasons.js',
  'server/routes/stats.js',
  'server/routes/teamMembers.js',
  'server/routes/teams.js',
  'server/routes/tess.js',
  'server/routes/time.js',
  'server/routes/umpires.js',
  'server/routes/users.js',
  'server/routes/venues.js',
  'server/routes/walkUpSongs.js',
  'server/schedule/gameApprovalOpenApi.js',
  'server/schedule/gameApprovals.js',
  'server/schedule/pendingProjection.js',
  'server/schedule/scheduleCursor.js',
  'server/schedule/scheduleGames.js',
  'server/schedule/seasonGameConsent.js',
  'server/scheduler/schedulingSetupOpenApi.js',
  'server/scheduler/setup.js',
  'server/scoreboard/attachScoreboard.js',
  'server/scoreboard/boardTimeline.js',
  'server/scoreboard/gameRecord.js',
  'server/scoreboard/gameSource.js',
  'server/scoreboard/scoreboardHub.js',
  'server/scoreboard/scoreboardLog.js',
  'server/scoreboard/scoreboardScript.js',
  'server/scoreboard/scoreboardService.js',
  'server/scoreboard/scoreboardStore.js',
  'server/scoring/gameStatistics.js',
  'server/scoring/gumboIds.js',
  'server/scoring/historicalStatistics.js',
  'server/scoring/lineTimeline.js',
  'server/scoring/mergeConflicts.js',
  'server/scoring/openRow.js',
  'server/scoring/projection.js',
  'server/scoring/replayContext.js',
  'server/scoring/rosterWrites.js',
  'server/sentry/instrument.js',
  'server/sentry/options.js',
  'server/serverConfig.js',
  'server/serverConfigSchema.js',
  'server/settings.js',
  'server/socket/bindUpgrades.js',
  'server/socket/chatFanout.js',
  'server/socket/chatSocketTestWorker.js',
  'server/socket/fanout.js',
  'server/socket/gameChanges.js',
  'server/socket/gameSocket.js',
  'server/socket/screenScope.js',
  'server/socket/spread.js',
  'server/socket/syncRevision.js',
  'server/stats.js',
  'server/stats/boxScoreOrder.js',
  'server/stats/expandedStats.js',
  'server/stats/gumboStats.js',
  'server/stats/plateAppearances.js',
  'server/stats/playerSplits.js',
  'server/stats/records.js',
  'server/stats/rows.js',
  'server/stats/seasonTeams.js',
  'server/stats/splits.js',
  'server/statsBuilder/builder.js',
  'server/statsBuilder/cli.js',
  'server/statsBuilder/main.js',
  'server/statsBuilder/request.js',
  'server/statsBuilder/serverHooks.js',
  'server/statsBuilder/start.js',
  'server/statsBuilder/status.js',
  'server/statsBuilder/supervisor.js',
  'server/stopWorker.js',
  'server/teams/addAdults.js',
  'server/teams/addExistingPlayer.js',
  'server/teams/addPlayers.js',
  'server/teams/createTeam.js',
  'server/teams/followMerges.js',
  'server/teams/personProfile.js',
  'server/teams/resolveOpponent.js',
  'server/teams/rosterCore.js',
  'server/teams/storeTeamPictures.js',
  'server/teams/teamNames.js',
  'server/teams/teamHeadCoach.js',
  'server/teams/teamRoster.js',
  'server/teams/teamStaff.js',
  'server/tess/agent.js',
  'server/tess/attachments.js',
  'server/tess/changes.js',
  'server/tess/compaction.js',
  'server/tess/conversation.js',
  'server/tess/denyList.js',
  'server/tess/liveUser.js',
  'server/tess/loopback.js',
  'server/tess/messagesApi.js',
  'server/tess/openApi.js',
  'server/tess/playerLinks.js',
  'server/tess/prompt.js',
  'server/tess/sitemapCli.js',
  'server/tess/sitemapGenerator.js',
  'server/tess/stepLabels.js',
  'server/tess/tess.integration.js',
  'server/tess/tools.js',
  'server/tess/turns.js',
  'server/tess/usage.js',
  'server/tess/userContext.js',
  'server/umpires/admin.js',
  'server/umpires/affiliations.js',
  'server/umpires/assignments.js',
  'server/umpires/context.js',
  'server/umpires/leaderboardPages.e2e.js',
  'server/umpires/notes.js',
  'server/umpires/openApi.js',
  'server/umpires/presence.js',
  'server/umpires/savePeople.js',
  'server/umpires/schedule.js',
  'server/umpires/types.js',
  'server/userIdSchema.js',
  'server/users/deleted.js',
  'server/users/insertUser.js',
  'server/users/mintUserId.js',
  'server/users/nameBook.js',
  'server/users/readerNames.js',
  'server/users/rosterCandidates.js',
  'server/users/survivors.js',
  'server/venues/fieldWarnings.js',
  'server/venues/occupancy.js',
  'server/venues/ownership.js',
  'server/venues/venueNotices.js',
  'server/venues/venues.js',
  'server/venues/venuesOpenApi.js'
])
